import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LogService } from 'src/app/core/services/log/log.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { PrestationFichier } from 'src/app/shared/models/prestationFichier';
import {
	AbstractControl,
	FormGroup,
	ValidationErrors,
	ValidatorFn
} from '@angular/forms';
import { Address } from 'src/app/shared/models/address';
import { Observable, of, Subscriber } from 'rxjs';
import { PARAM_LABEL_INTERVENANT } from 'src/app/core/services/constant/constants.service';
import { User } from 'src/app/shared/models/security/user';
import { NominatimResponse } from 'src/app/shared/models/api-response/nominatim-response';
import { Prestation } from 'src/app/shared/models/prestation';
import { Options } from '@angular-slider/ngx-slider';
import { Router } from '@angular/router';
import { TypeDocument } from 'src/app/shared/models/typeDocument';

@Component({
	selector: 'app-prestationFichier-form',
	templateUrl: './prestationFichier-form.component.html',
	styleUrls: ['./prestationFichier-form.component.scss']
})
export class PrestationFichierFormComponent implements OnInit {
	@Input() prestationFichier: PrestationFichier;
	@Input() prestation: Prestation;
	@Input() isAddForm: boolean;
	@Input() isAddressSelected: { value: boolean };
	@Input() isAddressDefault: { value: boolean };
	@Input() isAddressStructureSelected: { value: boolean };
	@Input() isAddressStructureDefault: { value: boolean };
	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	@Input() isValidateButtonClicked: { value: boolean };
	@Input() form: FormGroup;
	@Output() sendForm: EventEmitter<any> = new EventEmitter();
	@Output() hideModal: EventEmitter<any> = new EventEmitter();


	MAX_NAME_CHAR = 25;
	NAME_PATTERN = new RegExp("^[a-zA-z'éèàç.-_]+( [a-zA-z'éèàç.-_]+)*$");

	prestationFichiers: PrestationFichier[] = null;

	labelIntervenantCapitalized: string;

	selectedFile: File;

	listTypeDocument: TypeDocument[];

	isPreferencesActive = false;
	totalHeuresActivites = 0;

	options: Options;

	user: User;

	constructor(private logger: LogService, private facade: FacadeService, private router: Router) {
	
	}

	ngOnInit(): void {
		if (this.prestationFichier) {

			this.labelIntervenantCapitalized =
				this.facade.dataStorageService.getLabelCapitalized(
					PARAM_LABEL_INTERVENANT
				);
			this.user = this.facade.dataStorageService.getUser();

			this.isPreferencesActive =
				this.facade.dataStorageService.isPreferencesBeneficiaireActive();

			this.facade.typeDocumentService.getAllTypeDocument().subscribe({
				next: (val) => {
					this.listTypeDocument = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});
			

			const prestationId = +this.router.url.split('/').pop();
			this.facade.prestationService
			.getPrestationById(prestationId)
			.subscribe((prestation: Prestation) => {
				this.prestation = prestation;
			});

			// Deep copy
			//this.listSelectedIntervenant = [...this.prestationFichier.intervenants];

			if (!this.isAddForm) {
				this.form.patchValue({
					typeDocument: this.prestationFichier.typeDocument?.id,
				});
			} 

		}
	}

	selectFile(event) {  
		const file = event.target.files.item(0);  
	   
		var size = event.target.files[0].size;  
		// if(size > 1000000)  
		// {  
		// 	alert("size must not exceeds 1 MB");  
		// 	this.form.get('profileImage').setValue("");  
		// }  
		// else  
		// {  
			this.selectedFile = event.target.files[0];  
		//}  
	  
	  }     

	submitForm() {
		if (
			this.form.valid
		) {
			this.isValidateButtonClicked.value = true;
			this.prestationFichier.typeDocument = this.listTypeDocument.find(x => x.id == this.form.get('typeDocument').value);
			this.prestationFichier.prestation = this.prestation;
			this.prestationFichier.date = new Date().toISOString();
			console.log(this.selectedFile);
			this.prestationFichier.file = this.selectedFile;
			this.prestationFichier.filename = "";


			this.sendForm.emit();
		} else {
			// this.facade.toastService.createErrorToast();
			this.isValidateButtonClicked.value = false;
		}
	}

	get typeDocument() {
		return this.form.get('typeDocument');
	}

	
}
